module.exports = __webpack_public_path__ + "media/images/icons/filled/container-6b77867127b583b2a10a166365dd30e1.svg";